import { Component, Input } from '@angular/core';
import { PictureBasicCardEnum } from '../../enums/basic-card.enum';
import { BackgroundPictureType, SizePictureType } from '../../types/picture.type';

@Component({
    selector: 'app-picture',
    templateUrl: './picture.component.html',
    styleUrls: ['./picture.component.scss'],
    standalone: false
})
export class PictureComponent {
  readonly typePicture = PictureBasicCardEnum;

  @Input({ required: true }) type!: PictureBasicCardEnum;

  @Input({ required: true }) value!: string;

  @Input() size?: SizePictureType;

  @Input() background?: BackgroundPictureType; 
}
